/**
 * This file looks for the "sponsorRcn" URL param on any page and remembers it so
 * that it can be used by sign-up apps if the user ever goes to a sign-up app.
 * This is very similar to a normal "affiliate link" system.
 */

import Cookies from 'js-cookie';

const COOKIE_NAME = 'affiliate-link-sponsor-rcn';
const EXPERATION_TIME_DAYS = 30; // Thirty days
const KNOWN_DOMAIN_ROOT_ZONES = [
    '.com',
    '.co.uk',
    '.co.uk',
    '.ca',
    '.mx',
    '.fr',
    '.de',
    '.nl',
    '.co.uk',
    '.com.my',
    '.com.au',
    '.co.nz',
    '.com.ph',
];

/**
 * Returns the value of the requested URL param, or null if it does not exist.
 */
const getUrlParameterByName = (name: string, url: string) => {
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);
    if (!results) { return null; }
    if (!results[2]) { return ''; }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

/**
 * Returns the TLD if it can, otherwise just returns the input domain.
 */
const getTldFromDomain = (domain: string) => {
    for (const rootZone of KNOWN_DOMAIN_ROOT_ZONES) {
        if (domain.endsWith(rootZone)) {
            const domainDotCount = domain.split('.').length - 1;
            const rootZoneDotCount = rootZone.split('.').length - 1;
            // Return the TLD by chopping off any subdomains
            return domain.split('.').slice(domainDotCount - rootZoneDotCount).join('.');
        }
    }
    return domain; // If the domain root zone is not recignized, just return the domain.
};

export const checkForAffiliateLinkInUrl = () => {
    const sponsorRcn = getUrlParameterByName('sponsorRcn', window.location.href);
    if (sponsorRcn !== null) {
        const filteredSponsorRcn = sponsorRcn.replace(/\D/g, ''); // Filter out anything except numbers
        Cookies.set(COOKIE_NAME, filteredSponsorRcn, {
            domain: '.' + getTldFromDomain(window.location.hostname),
            expires: EXPERATION_TIME_DAYS,
        });
    }
};

export const getSessionSponsorRcn = (): string | null => {
    /**
     * Its nice to call the URL checker again here to deal with hash location changes that
     * did not re-render the page like in angular router or react router.
     */
    checkForAffiliateLinkInUrl();

    return Cookies.get(COOKIE_NAME);
};

// This is used by country selector UI components which are mostly server-side code.
// This could be removed later if they move to react.
// @ts-ignore
window.addAffiliateLinkSponsorRcnToCrossDomainLinkUrl = (linkUrl: string) => {
    const sponsorRcn = getSessionSponsorRcn();
    return linkUrl + (sponsorRcn ? ('?sponsorRcn=' + sponsorRcn) : '');
};
